var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"continueButton"},[_c('button',{ref:"continueButton",staticClass:"button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.go(_vm.to)}}},[_vm._v(_vm._s(_vm.text || 'Continue'))])])}
var staticRenderFns = []

export { render, staticRenderFns }